import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './breadcrumb.module.scss';
import Icon from '../icon/icon';

const Breadcrumb = ({ title, subtitle, baseUrl, variant }) => {
  return (
    <ul
      className={cn(styles.list, {
        [styles.pageTitleList]: variant === 'pageTitle',
      })}
    >
      <li>
        <Link
          to={baseUrl}
          className={cn(styles.title, {
            [styles.pageTitle]: variant === 'pageTitle',
          })}
        >
          {title}
        </Link>
      </li>
      {subtitle && (
        <li className={styles.subtitle}>
          <Icon name="chevron-right" classes={{ icon: styles.icon }} />
          {subtitle}
        </li>
      )}
    </ul>
  );
};

Breadcrumb.defaultProps = {
  subtitle: null,
  variant: 'default',
};

Breadcrumb.propTypes = {
  title: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'pageTitle']),
};

export default Breadcrumb;
